import { FormArrayRow, FormArrayRowProps } from 'src/components/Form';
import { getSolutionRuleConfigurationFilterFields } from '../formFields';

function SolutionRuleConfigurationEditFormRow({
  childFields,
  update,
  values,
  ...rest
}: FormArrayRowProps) {
  return (
    <FormArrayRow
      childFields={getSolutionRuleConfigurationFilterFields()}
      {...rest}
    />
  );
}

export default SolutionRuleConfigurationEditFormRow;
